import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./StepSubscription.module.scss";
import { FaUserAlt, FaHashtag } from "react-icons/fa";
import InputForms from "components/UiComponents/forms/InputForms";


const StepSubscription = ({ userData, updateUserData, onNext, onPrev, onValidChange }) => {
  const { t } = useTranslation();
  const [touched, setTouched] = React.useState({});
  const markTouched = (field) => setTouched((prev) => ({ ...prev, [field]: true }));

    useEffect(() => {
        if (!onValidChange) return;
        const hasSubscription = (userData.subscription || "").trim().length > 0;
        const hasSubid = (userData.subid || "").trim().length > 0;
        const hasPlan = (userData.plan || "").trim().length > 0;
        onValidChange(hasSubscription && hasSubid && hasPlan);
    }, [userData.subscription, userData.subid, userData.plan, onValidChange]);

    return (
        <div className={styles.container}>

            <div className={styles.grid2}>
                <div className={styles.fieldGroup} onBlur={() => markTouched("subscription")}>
                    <label htmlFor="subscription">{t("subscription.label")}</label>
                    <InputForms
                        type="text"
                        placeholder={t("subscription.label")}
                        value={userData.subscription}
                        onChange={(e) => updateUserData({ subscription: e.target.value })}
                        required
                        paddingLeft="40px"
                        svg={<FaUserAlt />}
                    />
                    {touched.subscription && !userData.subscription?.trim() && (
                        <span className={styles.fieldError}>{t("subscription.label_required")}</span>
                    )}
                </div>
                <div className={styles.fieldGroup} onBlur={() => markTouched("subid")}>
                    <label htmlFor="subid">{t("subscription.odoo_devis_label")}</label>
                    <InputForms
                        type="text"
                        placeholder={t("subscription.odoo_devis_label")}
                        value={userData.subid}
                        onChange={(e) => updateUserData({ subid: e.target.value })}
                        required
                        paddingLeft="40px"
                        svg={<FaHashtag />}
                    />
                    {touched.subid && !userData.subid?.trim() && (
                        <span className={styles.fieldError}>{t("subscription.plan_odoo_required")}</span>
                    )}
                </div>
            </div>

            <div className={styles.fieldGroup} onBlur={() => markTouched("plan")}>
                <label htmlFor="plan">{t("subscription.plan_label")}</label>
                <select
                    id="plan"
                    value={userData.plan}
                    onChange={(e) => updateUserData({ plan: e.target.value })}
                >
                    <option value="">{t("subscription.select_plan")}</option>
                    <option value="std">Standard</option>
                    <option value="pro">Pro</option>
                    <option value="plus">Plus</option>
                </select>
                {touched.plan && !userData.plan && (
                    <span className={styles.fieldError}>{t("subscription.plan_required")}</span>
                )}
            </div>

        </div>
    );
};

export default StepSubscription;
